<script setup lang="ts">
import { CommercialAgreement } from '@/core/collections/contracts-api/commercial-agreements/commercial-agreement.interface';
import Dropdown from './Dropdown.vue';

const props = defineProps({
   name: { type: String, required: true },
   label: { type: String, required: true },
   disabled: { type: Boolean, default: false },
   options: { type: Array as PropType<Array<CommercialAgreement>>, default: () => [] },
   errors: { type: Object, default: () => ({}) },
   multiselect: { type: Boolean, default: false },
});

const modelValue = defineModel<any>('modelValue', { default: undefined });

onMounted(() => {
   if (props.multiselect && !modelValue.value) {
      modelValue.value = [];
   }
});
</script>

<template>
   <Dropdown
      v-model="modelValue"
      :multiselect="multiselect"
      :name="label"
      :disabled="disabled"
      :options="options"
      :display-key="`performance_code.name.${$i18n.locale}`"
      :errors="errors"
      :label="label"
   >
      <template #option="{ option }: { option: CommercialAgreement }">
         <div class="container">
            <div class="row">
               <div class="col text-nowrap">
                  <strong>{{ $t('generic.code') }}:</strong> {{ option?.performance_code?.name?.[$i18n.locale] }}
               </div>
            </div>

            <div v-if="option?.job_profile?.name?.[$i18n.locale]" class="row">
               <div class="col">
                  <strong>{{ $t('employers.job-profiles.job-profile') }}:</strong> {{ option?.job_profile?.name?.[$i18n.locale] }}
               </div>
            </div>

            <div class="row">
               <div class="col">
                  <strong>{{ $t('commercial-agreements.coefficient') }}:</strong> {{ option?.coefficient ? +option.coefficient : '' }}
               </div>
            </div>

            <div v-if="option?.value !== undefined && option?.value !== null" class="row">
               <div class="col">
                  <strong>{{ $t('generic.amount') }}:</strong> {{ +option?.value }}
               </div>
            </div>
         </div>
      </template>
      <template #displayOption="{ option }">
         <div class="d-flex gap-1">
            <div>
               <strong>{{ $t('performance-codes.performance-code') }}:</strong> {{ option?.performance_code?.name?.[$i18n.locale] }}
            </div>

            <div v-if="option?.job_profile?.name?.[$i18n.locale]">
               <strong>{{ $t('employers.job-profiles.job-profile') }}:</strong> {{ option?.job_profile?.name?.[$i18n.locale] }}
            </div>

            <div>
               <strong>{{ $t('commercial-agreements.coefficient', 2) }}:</strong> {{ option?.coefficient ? +option.coefficient : '' }}
            </div>

            <div v-if="option?.value !== undefined && option?.value !== null && option.performance_code.key !== 'werkuren'">
               <strong> {{ $t('generic.amount', 2) }}: </strong>
               <span> - {{ +option?.value }} </span>
            </div>
         </div>
      </template>
   </Dropdown>
</template>
